<template>
    <h1>without layout </h1>
</template>

<script setup>
definePageMeta({
    layout: false,
})
</script>